import ko from 'knockout';

/**
 * Module to retrieve translated text
 */
function ResourceHelper() {

  var self = this;
  self.wrapTranslatedTextInBrackets = false;
  self.resourceData = ko.observable(null);

  /**
   *
   * @param {*} resourceData
   * @param {boolean} [wrapTranslatedTextInBrackets]
   */
  self.init = function (resourceData, wrapTranslatedTextInBrackets) {
    self.resourceData(resourceData);
    self.wrapTranslatedTextInBrackets = wrapTranslatedTextInBrackets || self.wrapTranslatedTextInBrackets;
  };

  self.registerPackageResourceData = function (packageResourceData, packageName, languageCode) {

    if (!self.resourceData()) {
      throw new Error('The resource helper must be initialised before any any package resource data can be registered');
    }

    // Combine the package resource data with the existing resource ensuring any existing keys are not
    // overridden. The resource data registered during initialisation should always take precedence.
    var tempResourceData = ko.utils.extend({}, packageResourceData);
    self.resourceData(ko.utils.extend(tempResourceData, self.resourceData()));

    console.debug(
      'Package', packageName, 'registered resource data with',
      Object.keys(packageResourceData).length, 'keys for the language code', languageCode);
  };

  /**
   * Gets a localised string for the given resource key
   * @param {string} resourceKey
   * @return {string}
   */
  self.getString = function (resourceKey) {

    if (!self.resourceData()) {
      throw new Error('The resourceData has not been populated');
    }

    var value = self.resourceData()[resourceKey];

    if (value) {

      if (self.wrapTranslatedTextInBrackets) {
        return '|' + value + '|';
      }

      return value;
    }

    return '[!' + resourceKey + '!]';
  };

  /**
   * Takes a string with placeholders and replaces values from a object with replacements
   * @example "Hello {name}", { name: 'Bob' } = "Hello Bob"
   * @param {string} stringWithPlaceholders
   * @param {*} replacementValues Object with property names that match the placeholder names
   * @return {string}
   */
  self.replacePlaceholders = function (stringWithPlaceholders, replacementValues) {
    if (replacementValues) {

      Object.entries(replacementValues).forEach(([replaceKey, replacement]) => {

        if (typeof replacement === 'function') {
          replacement = ko.utils.unwrapObservable(replacement());
        }

        stringWithPlaceholders = stringWithPlaceholders.replace('{' + replaceKey + '}', replacement);
      });
    }

    return stringWithPlaceholders;
  };

  /**
   * If there is code that might use the resource helper before the SPA has loaded / the resource data
   * is retreived then this method should be used to determine if the resource data exists before
   * attempting to retrieve a translated string.
   * @return {bool}
   */
  self.hasResourceData = function () {
    return !!self.resourceData(); // Convert truthy value to true
  };
}

export default new ResourceHelper();

